import { Box, Typography } from '@mui/material';

export const CalcAIInsights = () => {

  const data = {
  oneLineSummary:
    'For Kit NDC 61958987601, Direct Sales, Indirect Sales (chargebacks), and Rebates were reallocated to underlying product NDCs 61958123402 and 61958567802 using a WAC‑based allocation methodology derived directly from the price list.',
  bulletPoints: [
    'The product WACs are $3,500.00 for NDC 61958123402 and $5,000.00 for NDC 61958567802',
    'NDC 61958123402 is allocated 41.18%',
    'NDC 61958567802 is allocated 58.82%'
  ],
  fullSummary:
    'For each transaction source (Direct Sales, Indirect Sales, and Rebates), the product‑level totals reconcile exactly to the corresponding kit‑level total, confirming full dollar preservation. Differences between the product NDC results are attributable solely to the WAC‑based allocation methodology and do not reflect differences in transaction volumes, channel behavior, or pricing mechanics, ensuring accurate Government Pricing attribution at the product NDC level.'
};

  return (
    <>
      {/* TL;DR */}
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        {data.oneLineSummary}
      </Typography>

      {/* Bulleted highlights */}
      <Box component="ul" sx={{ pl: 2.5, mt: 0, mb: 1.5, '& li': { mb: 0.5 } }}>
        {data.bulletPoints.map((bulletPoint, index) =>
          <li key={index}>
            <Typography variant="body2">
              {bulletPoint}
            </Typography>
          </li>
        )}
      </Box>

      {/* Original narrative (narrow measure for readability) */}
      <Typography variant="body2" sx={{ lineHeight: 1.25 }}>
        {data.fullSummary}
      </Typography>
    </>
  )
}